import { fromJS } from 'immutable';
import {
  RESET_STORE_OPEN_CLAIM,
  SET_SEARCH_CLAIM_INFO,
} from 'containers/OpeningClaimPageManager/constants';

export interface OpenClaimAction {
  type: string;
  claim: any;
  claimInfo: any;
  payload: any;
}

const initialState: any = fromJS({
  claim: {},
  claimInfo: {},
});

const OpenClaimReducer = (state = initialState, action: OpenClaimAction) => {
  switch (action.type) {
    case SET_SEARCH_CLAIM_INFO:
      return state.set('claimInfo', fromJS(action.payload));
    case RESET_STORE_OPEN_CLAIM:
      return initialState;
    default:
      return state;
  }
};

export default OpenClaimReducer;
